/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject } from '@angular/core';
import { signalStore, withState, withMethods, patchState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { map, pipe, switchMap, tap } from 'rxjs';
import { CountryVoModel, CountyVoModel } from '@well/common-libs/country-management/domain-model';
import { CountryVoResourceService, CountyVoResourceService } from '@well/common-libs/country-management/data-access';

interface CountryState {
  countries: CountryVoModel[];
  counties: CountyVoModel[];
}

const initialState: CountryState = {
  countries: [],
  counties: [],
};

export const CountryStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),

  withMethods((store, countryService = inject(CountryVoResourceService), countyService = inject(CountyVoResourceService)) => ({
    loadCountries: rxMethod<void>(
      pipe(
        switchMap(() => countryService.findAll().pipe(map((res) => res.data))),
        tap((countries: CountryVoModel[]) => patchState(store, { countries }))
      )
    ),

    loadCounties: rxMethod<void>(
      pipe(
        switchMap(() => countyService.findAll().pipe(map((res) => res.data))),
        tap((counties: CountyVoModel[]) => patchState(store, { counties }))
      )
    ),

    setCountries(countries: CountryVoModel[]): void {
      patchState(store, { countries });
    },

    setCounties(counties: CountyVoModel[]): void {
      patchState(store, { counties });
    },
  }))
);
